import { Box, styled, Theme } from '@mui/material';

export const StatusBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'max-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'transparent',
    gap: '8px',
    padding: '8px',
    borderRadius: '8px',
    flexShrink: 0,

    '> p': {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '128%',
    },

    '&.yellow': {
      color: '#D49D0E',
      backgroundColor: '#FFF6E0',
    },

    '&.red': {
      color: '#942020',
      backgroundColor: '#FFF1F1',
    },

    '&.purple': {
      color: '#663497',
      backgroundColor: '#F5EFFA',
    },

    '&.green': {
      color: '#85C553',
      backgroundColor: '#F3F9EE',
    },

    '&.blue': {
      color: '#267591',
      backgroundColor: '#DDF6FF',
    },
  };
});
